import { render, staticRenderFns } from "./OrderSendingDialog.vue?vue&type=template&id=5e1b23a4&scoped=true"
import script from "./OrderSendingDialog.vue?vue&type=script&lang=js"
export * from "./OrderSendingDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderSendingDialog.vue?vue&type=style&index=0&id=5e1b23a4&prod&lang=scss&scoped=true"
import style1 from "./OrderSendingDialog.vue?vue&type=style&index=1&id=5e1b23a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1b23a4",
  null
  
)

export default component.exports